import React from 'react';
import { ImageIcon } from 'lucide-react';
interface ImagePlaceholderProps {
  label: string;
  className?: string;
  /** Aspect ratio utility, e.g. "aspect-[4/5]". */
  ratio?: string;
  compact?: boolean;
}
export function ImagePlaceholder({
  label,
  className = '',
  ratio = 'aspect-[4/3]',
  compact = false
}: ImagePlaceholderProps) {
  return <div role="img" aria-label={label} className={`flex ${ratio} w-full flex-col items-center justify-center gap-2 rounded-card border border-dashed border-[#C9D2D0] bg-[#EDEFEE] p-3 text-center ${className}`} data-id="element-137" data-mp="r6jm0gxikzcv">
      <ImageIcon className={`${compact ? 'h-4 w-4' : 'h-6 w-6'} text-[#8B9795]`} strokeWidth={1.5} aria-hidden="true" data-id="element-138" data-mp="d60k7rjn6pj5" />
      <span className={`${compact ? 'text-[9px]' : 'text-[11px]'} font-semibold uppercase leading-tight tracking-wide text-[#7A8785]`} data-id="element-139" data-mp="8eiih19sokx4">
        {label}
      </span>
    </div>;
}